import { useParams, useLocation } from 'react-router-dom';
import { getDomainById, DOMAINS } from '@/domain-registry';

/**
 * Extract domain from URL - single source of truth
 * No state management, pure derivation from URL
 */
export function useDomainFromUrl() {
  const { domain } = useParams<{ domain: string }>();
  const location = useLocation();
  
  // Fallback: extract from pathname if params don't have domain
  const extractDomainFromPath = (pathname: string): string => {
    const segments = pathname.replace(/^\//, '').split('/');
    const potentialDomain = segments[0];
    
    if (potentialDomain && DOMAINS[potentialDomain]) {
      return potentialDomain;
    }
    
    return 'billing'; // Default fallback
  };
  
  // Use domain from params, or extract from path, or fallback to billing
  const currentDomain = domain || extractDomainFromPath(location.pathname);
  const domainConfig = getDomainById(currentDomain);
  
  return {
    currentDomain,
    domainConfig: domainConfig || null,
    isValidDomain: !!domainConfig
  };
}